import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/Navbar/Navbar.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/Navbar/Navlinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/Toasts/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.1.0_next@15.3.3_@opentelemetry+api@1.9.0_react-dom@19.0.0-rc.1_react@19.0.0_5e3b430f8ca3ed4397a3b801facceecc/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/main.css");
